'use client';

import { c as _c } from "react/compiler-runtime";
import { FadeUp } from '@algoacademy/design-system/web/marketing/animation/FadeUp';
import { TeacherCard } from '../../_components/TeacherCard';
import { ContactForm } from '../../_forms/ContactForm';
import { Courses } from '../../_sections/courses/Courses';
import { Education } from '../../_sections/education/Education';
import { Experience } from '../../_sections/experience/Experience';
import { HowIWork } from '../../_sections/how-i-work/HowIWork';
import { Reviews } from '../../_sections/reviews/Reviews';
import { Technologies } from '../../_sections/technologies/Technologies';
import { MOCKED_DATA } from './mockData';
export default function PortfolioPage() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FadeUp><TeacherCard name={MOCKED_DATA.name} aboutMe={MOCKED_DATA.aboutMe} photoUrl={MOCKED_DATA.photoUrl} cvUrl={MOCKED_DATA.cvUrl} socials={{
        linkedinUrl: MOCKED_DATA.socials.linkedinUrl,
        githubUrl: MOCKED_DATA.socials.githubUrl,
        youtubeUrl: MOCKED_DATA.socials.youtubeUrl
      }} /></FadeUp>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FadeUp><Technologies technologies={MOCKED_DATA.technologies.skills.map(_temp)} /></FadeUp>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FadeUp><Courses courses={MOCKED_DATA.courses.map(_temp3)} /></FadeUp>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FadeUp><Reviews reviews={MOCKED_DATA.reviews.map(_temp4)} /></FadeUp>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FadeUp><Experience workExperiences={MOCKED_DATA.experiences.map(_temp6)} /></FadeUp>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FadeUp><Education education={MOCKED_DATA.education.map(_temp8)} /></FadeUp>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FadeUp><HowIWork markdown={MOCKED_DATA.howIWorkMarkdown || "### Jak pracuj\u0119"} /></FadeUp>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <main className="flex flex-col items-center space-y-10 lg:space-y-20">{t0}{t1}{t2}{t3}{t4}{t5}{t6}<FadeUp><ContactForm email={MOCKED_DATA.email ?? "kontakt@algoacademy.pl"} githubUrl={MOCKED_DATA.socials.githubUrl ?? ""} linkedinUrl={MOCKED_DATA.socials.linkedinUrl ?? ""} youtubeUrl={MOCKED_DATA.socials.youtubeUrl ?? ""} /></FadeUp></main>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}
function _temp8(education) {
  return {
    institution: education.institution,
    degree: education.degree,
    description: education.description ?? "Brak opisu",
    skills: education.skills.map(_temp7),
    from: education.from,
    to: education.to
  };
}
function _temp7(skill_2) {
  return {
    name: skill_2.name,
    level: skill_2.level === "expert" ? "advanced" : skill_2.level ?? "basic"
  };
}
function _temp6(experience) {
  return {
    company: experience.company,
    role: experience.role,
    description: experience.description ?? "Brak opisu",
    from: experience.from,
    to: experience.to,
    skills: experience.skills.map(_temp5)
  };
}
function _temp5(skill_1) {
  return {
    name: skill_1.name,
    level: skill_1.level === "expert" ? "advanced" : skill_1.level ?? "basic"
  };
}
function _temp4(review) {
  return {
    id: review.id,
    author: review.reviewerName,
    rating: review.reviewerRating,
    title: review.title,
    content: review.description ?? "Brak tre\u015Bci",
    avatarUrl: review.reviewerAvatarUrl
  };
}
function _temp3(course) {
  return {
    name: course.name,
    skills: course.skills.map(_temp2),
    description: course.description ?? "Brak opisu"
  };
}
function _temp2(skill_0) {
  return {
    name: skill_0.name,
    level: skill_0.level === "expert" ? "advanced" : skill_0.level ?? "basic"
  };
}
function _temp(skill) {
  return {
    name: skill.name
  };
}